import React from 'react'
import UnexpectedErrorBoundary from 'components/UnexpectedErrorBoundary'
import messageUtil from 'utils/messageUtil'

import { AudienceSentimentWidget as AudienceSentimentWidgetType } from 'schemas/AudienceSentimentWidgetSchema'
import { useDashboardWidgetSetting } from 'hooks/useDashboardState'
import { TopicNotSelectedGuard, WidgetLoadingGuard } from 'components/widget/share/guards'
import { getLabel } from 'utils/widgetTypeUtil'
import { CountType } from 'enums'
import SentimentWidgetDataGuards from '../share/guards/SentimentWidgetDataGuards'
import Sentiment from '../share/Sentiment'
import RunSearchEffect from './RunSearchEffect'
import InsightModal from '../share/InsightModal'
import useSelectedInsights from '../share/InsightModal/hooks/useSelectedInsights'

interface AudienceSentimentWidgetProps {
  widgetId: number
}

const AudienceSentimentWidget = ({
  widgetId
}: AudienceSentimentWidgetProps): React.ReactElement => {
  const widgetSetting = useDashboardWidgetSetting<AudienceSentimentWidgetType>(widgetId)
  const {
    isModalOpen,
    selectedInsights,
    detailSetting,
    widgetSettingWithSelection,
    onClick,
    onClose
  } = useSelectedInsights(widgetSetting)

  return (
    <UnexpectedErrorBoundary>
      <TopicNotSelectedGuard widgetId={widgetId}>
        <RunSearchEffect widgetId={widgetId}>
          <WidgetLoadingGuard widgetId={widgetId}>
            <SentimentWidgetDataGuards widgetId={widgetId}>
              <Sentiment
                widgetId={widgetId}
                seriesName={messageUtil.countType(widgetSetting.countType!)}
                onClick={onClick}
              />
            </SentimentWidgetDataGuards>
          </WidgetLoadingGuard>
        </RunSearchEffect>
      </TopicNotSelectedGuard>
      <InsightModal
        open={isModalOpen}
        onClose={onClose}
        title={widgetSetting?.name || getLabel(widgetSetting?.type)}
        countType={widgetSetting.countType! || CountType.MENTIONS}
        selectedInsights={selectedInsights}
        detailSetting={detailSetting}
        widgetSettingWithSelection={widgetSettingWithSelection}
      />
    </UnexpectedErrorBoundary>
  )
}

export default AudienceSentimentWidget
